import { rdEquipamentosService } from '@/services/quotes/rd-equipamentos';
import { STALE_TIME_FIVE_MINUTES_MS } from '@/shared/constants/query-stale-time.constants';
import { useQuery } from '@tanstack/react-query';

export function useRdFranchiseRules() {
  return useQuery({
    queryKey: ['rd-franchise-rules'],
    queryFn: async () => {
      const response = await rdEquipamentosService.getFranchiseRules();
      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar as regras de franquia do produto'
        );
      }

      return response.data;
    },
    staleTime: STALE_TIME_FIVE_MINUTES_MS,
  });
}
